import React from "react";
import {
  MainPageContainer,
  PodcastsListWrapper,
  ReleasesListWrapper,
} from "./styled";
import RadioChannelsList from "../../components/RadioChannelsList";
import { TitleWithBorder } from "../../components/TitleWithBorder/TitleWithBorder";
import NothingFound from "../../components/NothingFound";
import ReleasesList from "../../components/ReleasesList";
import PageContainer from "../../components/PageContainer";
import MainPodcastsListWrapper from "../../components/MainPodcastsListWrapper";
import {
  useGetPodcastsQuery,
  useGetReleasesQuery,
} from "../../api/podcastsApi";
import { Banner } from "./Banner";
import { useDispatch } from "react-redux";
import { setReleasePodcastInfo } from "../../redux/Slice/releasePodcastSlice";
import { openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { sortByPublishAt } from "../../utils/sortByPublishAt";

export const MainPage = () => {
  const {
    data: podcasts,
    isError: isPodcastsError,
    isLoading: isPodcastsLoading,
  } = useGetPodcastsQuery();
  const {
    data: latestReleases,
    isError: isLatestReleasesError,
    isLoading: isLatestReleasesLoading,
  } = useGetReleasesQuery("latest");

  const isLoading = isPodcastsLoading || isLatestReleasesLoading;

  const dispatch = useDispatch();

  const sortLatestReleases = sortByPublishAt(latestReleases);

  const handleClickCardRelease = (release) => {
    dispatch(setReleasePodcastInfo(release));

    dispatch(openModal(modalState.RELEASE_PODCAST_INFO));
  };

  if (isPodcastsError || isLatestReleasesError) {
    return <NothingFound />;
  }

  return (
    <MainPageContainer as={PageContainer}>
      <Banner />
      <RadioChannelsList />
      <PodcastsListWrapper fullWidth={!sortLatestReleases?.length}>
        <TitleWithBorder>Подкасты</TitleWithBorder>
        <MainPodcastsListWrapper podcasts={podcasts} isLoading={isLoading} />
      </PodcastsListWrapper>
      {!!sortLatestReleases?.length && (
        <ReleasesListWrapper>
          <TitleWithBorder>Последние выпуски</TitleWithBorder>
          <ReleasesList
            releases={sortLatestReleases}
            isLoading={isLoading}
            podcasts={podcasts}
            onClickCardRelease={handleClickCardRelease}
          />
        </ReleasesListWrapper>
      )}
    </MainPageContainer>
  );
};
